<label *ngIf="label" [attr.for]="!id ? null : id">{{label}}</label>
<select [attr.id]="!id ? null : id" [attr.name]="!name ? null : name" [(ngModel)]="itemModel" [class]="htmlClass" [class.placeholderish]="itemModel === null && !gotFocus"
    (focus)="gotFocus=true" (blur)="gotFocus=false" [attr.data-select-id]="!dataId ? null : dataId">
    <option *ngIf="placeholder" [ngValue]="null" [innerHTML]="placeholder"></option>
    <ng-container *ngFor="let item of items">
        <option *ngIf="valuesArePrimitive"  value="{{item[key]}}">{{item[text]}}</option>
        <option  *ngIf="!valuesArePrimitive" [ngValue]="item[key]">{{item[text]}}</option>
    </ng-container>
</select>